"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const signatureCanvas_1 = require("./signatureCanvas");
const formField_1 = require("./fields/formField");
const modal_1 = require("./modal");
const botones_1 = require("./botones");
class SignaturePad extends React.Component {
    constructor(props) {
        super(props);
        this.handleEditar = () => {
            this.setState({ editando: true, firmaTemp: [] });
        };
        this.handleGuardar = () => {
            this.setState({ editando: false });
            if (this.props.onChange) {
                this.props.onChange(this.state.firmaTemp);
            }
        };
        this.handleOnChange = (value) => {
            this.setState({ firmaTemp: value });
        };
        this.handleLimpiar = () => {
            this.setState({ firmaTemp: [] });
        };
        this.handleCancelar = () => {
            this.setState({ editando: false });
        };
        this.state = { editando: false, firmaTemp: [] };
    }
    render() {
        let x;
        return (React.createElement("div", { style: { display: "flex", flexFlow: "column" } },
            React.createElement(formField_1.FormField, { error: this.props.error, label: this.props.label }, (this.props.value || []).length > 0 &&
                React.createElement("div", { style: { width: "100%", height: "200px" }, className: "well" },
                    React.createElement(signatureCanvas_1.SignatureCanvas, { zoomToFit: true, value: this.props.value || [] }))),
            !this.props.readonly &&
                React.createElement("div", { style: { alignSelf: "flex-start" } },
                    React.createElement(botones_1.Button, { style: "info", iconClass: "fa fa-pencil", onClick: this.handleEditar }, "Editar firma")),
            this.state.editando &&
                React.createElement(modal_1.Modal, { title: "Escriba su firma aqu\u00ED:", buttons: [
                        React.createElement(botones_1.Button, { key: "0", onClick: this.handleLimpiar, iconClass: "fa fa-trash", style: "danger" }, "Limpiar"),
                        React.createElement(botones_1.GuardarButton, { key: "1", onClick: this.handleGuardar })
                    ], fullScreen: true, onClose: this.handleCancelar },
                    React.createElement("div", { style: { flex: 1, display: "flex" } },
                        React.createElement(signatureCanvas_1.SignatureCanvas, { value: this.state.firmaTemp, onChange: this.handleOnChange })))));
    }
}
exports.SignaturePad = SignaturePad;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/signature.js
// module id = 2255
// module chunks = 0